import { createSelector } from 'reselect';

export const getPreferencesAccessor = state => state.preferences;

export const preferencesSelector = createSelector(getPreferencesAccessor, preferences => preferences)